<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive mb-0">
              <template v-for="o in orders" >{{o.id}};{{o.status}};{{o.gender}};{{o.firstname}};{{o.name}};{{o.company}};{{o.email}};{{o.tickets.length}}; <br :key="o.id" /></template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Repository from "@/repositories/RepositoryFactory";
const OrderRepository = Repository.get("orders");

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
/**
 * Ticket Orders Component
 */
export default {
  page: {
    title: "Ticket Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      orders: [],
      title: "Ticket Orders",
      items: [
        {
          text: "Ticket Orders",
          href: "/orders",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      statData: [

      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10000,
      //pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "company",
      sortDesc: false,
      fields: [
        {
          key: "company",
          sortable: true,
        },
        {
          key: "count",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "orderDate",
          sortable: true,
        },
        /*{
          key: "comments",
          sortable: true,
        },*/
        {
          key: "actions",
          sortable: false,
        },
      ],
      tableData: [],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
  },
  created() {
    this.getOrders();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.tableData.length;
  },
  methods: {
    getOrders: async function() {
      const { data } = await OrderRepository.getAll();
      this.orders = data;
    },
  },
};
</script>